<template>
    <div class="range_picker_components">
        <a-date-picker style="width:140px" :allowClear="false"
            v-model="start_dt" :defaultValue="defaultValue[0]" @change="(date, dateString)=>changeVal(date, dateString, 'start')"
        />
        ~
        <a-date-picker style="width:140px" :allowClear="false"
            v-model="end_dt" :defaultValue="defaultValue[1]" @change="(date, dateString)=>changeVal(date, dateString, 'end')"
        />
    </div>
</template>

<script>
import {Radio, Checkbox, DatePicker} from 'ant-design-vue';
import Vue from 'vue'
Vue.use(Radio)
Vue.use(Checkbox)
// this.$i18n.locale
export default {
    props:['placeholder',  'value', 'defaultValue'],
    created() {
    },
    watch: {
        value(newV, oldV) {
            if(newV && newV.length >= 2) {
                this.start_dt = newV[0]
                this.end_dt = newV[1]
            }
        },
    },
    data() {
        return {
            start_dt: this.defaultValue[0],
            end_dt: this.defaultValue[1],
        }
    },
    methods: {
        changeVal(date, dateString, type) {
            let val = [this.start_dt, this.end_dt]
            if(type === 'start') {
                this.start_dt = date
                val[0] = date
            }
            else {
                this.end_dt = date
                val[1] = date
            }
            this.$emit("change", [this.start_dt, this.end_dt])
            this.$emit("input", [this.start_dt, this.end_dt])
        },
    }
}
</script>
<style lang="less" scoped>

</style>